jQuery(document).ready(function() {
	var jQ = jQuery;
	var selectors = {
		TOTAL_ITEMS: '.cart-total-items .items-count',
		TOTAL_PRICE: '',
		SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',
		FORM_ADD_TO_CART: 'form[action*="/cart/add"]',
		FORM_UPDATE_CART: 'form[name=cartform]',
		FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
		FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',
		LINE_ITEM_ROW: '.cart-line-item',
		LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
		LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',
		LINE_ITEM_REMOVE: '.remove a',
		EMPTY_CART_MESSAGE: '#empty'
	};
	var text = {
		ITEM: 'Item',
		ITEMS: 'Items'
	};
	var formatMoney = function(price) {
			return Shopify.formatMoney(price, '${{ amount }}');

		};
	$('#testhook').on('click', function() {
		console.log('test hook');
	});
	function add_to_cart_supermarche_and_ajax(target) {
		var minLength = 1; // Minimum length
		var quantityId = $(target).find(".quantity");
		if(quantityId.val() < minLength){
		console.log("nope");
		quantityId.val(1);
		alert("Quantity must be greater than or equal to 1");
		}
		else {
		console.log('e.target: ', target);
		jQ(target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');
		Shopify.addItemFromForm(target);
		var submitButton = $(target).find(".submit-add-to-cart");
		console.log('submitButton: ', submitButton);
		addToCart(submitButton);
		}
	}
	jQ(selectors.FORM_ADD_TO_CART).submit(function(e) {
		e.preventDefault();
		add_to_cart_supermarche_and_ajax(e.target);
	});
	jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
		e.preventDefault();
		jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
		Shopify.updateCartFromForm(e.target.form);
	});
	jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
		e.preventDefault();
		var vid = this.href.split('/').pop().split('?').shift();
		Shopify.removeItem(vid);
		jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
	});
	Shopify.onItemAdded = function(line_item, form) {
		jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
		Shopify.getCart();
		setTimeout(function() {
			$('.nav-cart').addClass('pulsate')
		}, 2200);
		setTimeout(function() {
			$('.nav-cart').removeClass('pulsate');
		}, 2500);
	};
	$("#wishl-wrapper").on("submit", "form[action*='/cart/add']", function(e) {
		e.preventDefault();
		console.log('button clicked from favorites page');
		var target = $(e.target).closest('form');
		console.log('target: ', target);
		add_to_cart_supermarche_and_ajax(target);
	});
	
	function addToCart(submitButton) {
		// submitButton.find("i.fa-check").css('display', 'inline-block');
		// submitButton.find("i.fa-plus").css('display', 'none');
		// submitButton.css('border-color', '#8B0204');
		// submitButton.parent().parent().find(".in-cart-overlay").css('display', 'block');
		// submitButton.parent().parent().find(".in-cart-overlay i").css('display', 'block');
		// console.log("submitButton: ", submitButton);
		// var prodname = submitButton.closest("#add-to-cart-animation-wrapper").find('.grid-title').text();
		// console.log('prodname: ', prodname);
		// var proddesc = submitButton.closest("#add-to-cart-animation-wrapper").find('.grid-desc').text();
		// console.log('proddesc: ', proddesc);
		// var prodquantity = submitButton.closest("#add-to-cart-animation-wrapper").find('.quantity').val();
		// console.log('prodquantity: ', prodquantity);
		// var prodvar;
		// if (submitButton.closest("#add-to-cart-animation-wrapper").find(".product-select option:selected").text().indexOf('Default') >= 0) prodvar = '';
		// else prodvar = submitButton.closest("#add-to-cart-animation-wrapper").find(".product-select option:selected").text();
		// if (!prodvar) {
		// 	prodvar = submitButton.closest("#add-to-cart-animation-wrapper").find('.variant-title').text();
		// 	prodvar = prodvar.replace('- ', '');
		// }
		// console.log('prodvar: ', prodvar);
		// if ($("#favourites").length > 0) {
		// 	$("#modal-cart-alert .prod-caption").html('<span class="prodquantity">' + prodquantity + 'X</span>' + ' ' + prodname + '<br/>' + '<span class="proddesc"> ' + proddesc + '</span>');
		// 	console.log('favourites page')
		// }
		// else {$("#modal-cart-alert .prod-caption").html('<span class="prodquantity">' + prodquantity + 'X</span>' + ' ' + prodname + '<br/>' + '<span class="proddesc">' + prodvar + ' ' + proddesc + '</span>');}
		// $('#cartalert').click();
		// setTimeout(function() {
		// 	$(".submit-add-to-cart").css('border-color', '#8bb43f')
		// }, 1000);
		// setTimeout(function() {
		// 	$('#modal-cart-alert').addClass('bounceInstart slideInDown alertflex')
		// }, 0);
		// setTimeout(function() {
		// 	$('#modal-cart-alert').removeClass('hidden')
		// }, 0);
		// setTimeout(function() {
		// 	$('#modal-cart-alert').addClass('slideOutUp')
		// }, 2000);
		// setTimeout(function() {
		// 	$('#modal-cart-alert').removeClass('slideOutUp bounceInstart slideInDown alertflex')
		// }, 2200);
		// setTimeout(function() {
		// 	$('#modal-cart-alert').addClass('hidden')
		// }, 2200);
		// submitButton.closest("#add-to-cart-animation-wrapper").find('.quantity').val(1);
		// submitButton.closest("#add-to-cart-animation-wrapper").find('.minus-btn').addClass('invisible');
	}
	
	Shopify.onCartUpdate = function(cart, form) {
		var message = '<span class="cart-total-items">' + cart.item_count + ' </span>';
		jQ(selectors.TOTAL_ITEMS).html(message);
		var price = formatMoney(cart.total_price);
		jQ(selectors.TOTAL_PRICE).html(price);
		if ((jQ(selectors.EMPTY_CART_MESSAGE).length > 0) && cart.item_count == 0) {
			jQ(selectors.FORM_UPDATE_CART).hide();
			jQ(selectors.EMPTY_CART_MESSAGE).show();
		}
		form = form || false;
		if (form) {
			if (cart.item_count > 0) {
				jQ.each(cart.items, function(index, cartItem) {
					jQ(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(formatMoney(cartItem.line_price));
					jQ(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
				});
				jQ(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();
				jQ(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');
			}
		}
	};
	Shopify.onError = function(XMLHttpRequest, textStatus) {};
});

 $('.grid-product-image-holder').click(function () {
	 var imagePosition = $(this).closest('.item').attr("data-position");
	 $(this).closest(".item").addClass("imageFadeInOut"); 
	 $(this).toggleClass("large-image");
	 $(this).closest(".item").toggleClass("large-item");
	 setTimeout(function() {
	 	$('html, body').animate({scrollTop: $('.' + imagePosition).offset().top - 70}, 300);
	 }, 450);
	 setTimeout(function() {
		  $(".item").removeClass("imageFadeInOut");
	  }, 1000);
   });
   
   // LAYOUT PREFERENCE
   $(document).ready(function(){
	   if (Cookies("layoutpref") == null) {
	   Cookies('layoutpref', 'compact', {path: '/', domain: 'supermarchepa.com', expires: 365});
	   $('.compact-select').addClass('layout-current');
	   }
	   else if (Cookies("layoutpref") == "compact") {
		  Cookies('layoutpref', 'compact', {path: '/', domain: 'supermarchepa.com', expires: 365});
		  $('.compact-select').addClass('layout-current');
		  $('.expanded-select').removeClass('layout-current');
		  }
	   else if (Cookies("layoutpref") == "expanded"){
		   Cookies('layoutpref', 'expanded', {path: '/', domain: 'supermarchepa.com',expires: 365});
		   $(".item").addClass("large-item"); 
		   $(".grid-product-image-holder").addClass("large-image");
		   $(this).addClass('layout-current');
		   $('.compact-select').removeClass('layout-current');
		   $('.expanded-select').addClass('layout-current');
		   };
	});
	   
	   $(".compact-select").on("click", function(e) {
	   e.preventDefault();
		Cookies('layoutpref', 'compact', {path: '/',	domain: 'supermarchepa.com',expires: 365});
		$(".item").removeClass("large-item"); 
		$(".grid-product-image-holder").removeClass("large-image");
		$(this).addClass('layout-current');
		$('.expanded-select').removeClass('layout-current');
	   });
	   
	   $(".expanded-select").on("click", function(e) {
	   e.preventDefault();
	   Cookies('layoutpref', 'expanded', {path: '/',	domain: 'supermarchepa.com',expires: 365});
	   $(".item").addClass("large-item"); 
	   $(".grid-product-image-holder").addClass("large-image");
	   $(this).addClass('layout-current');
	   $('.compact-select').removeClass('layout-current');
	   });
   
		
		
	/////////////////////////////////// WEIGHT PREFERENCES
	$(document).ready(function(){
		if (Cookies("weightpref") == null) {
		Cookies('weightpref', 'lb', {path: '/', domain: 'supermarchepa.com', expires: 365});
		}
		else if (Cookies("weightpref") == "kg"){
		  $( '.grid-pref-holder .kg' ).addClass('current-weight');
		  $( '.grid-pref-holder .lbs' ).removeClass('current-weight');
			};
	 });
		
		$(".grid-pref-holder .kg").on("click", function(e) {
		e.preventDefault();
		 $( '.kg .lbs' ).toggleClass('current-weight');
		 Cookies('weightpref', 'kg', {path: '/',	domain: 'supermarchepa.com',expires: 365});
		 location.reload();
		});
		
		$(".grid-pref-holder .lbs").on("click", function(e) {
		e.preventDefault();
		$( '.kg .lbs' ).toggleClass('current-weight');
		Cookies('weightpref', 'lb', {path: '/',	domain: 'supermarchepa.com',expires: 365});
		location.reload();
		});
		
		
//  FILTER MENU
	$('.grid-filter-holder').click(function () {
		$(this).addClass('filter-active');
    });
  
  	$('.grid-filter-close').click(function (e) { 
		$('.grid-filter-holder').removeClass('filter-active');
		e.stopPropagation();
	});
	
	// ALL DEPARTMENTS MENU
	$('.all-depts-holder').click(function () {
		$(".top-blur-overlay").addClass("top-blur-overlay-active");
		$('.all-depts-holder-list-mobile').addClass('all-depts-holder-list-mobile-hide');
		$(".nav-cart").addClass('nav-cart-hidden');
		$('#top-nav, #logo, .checkout').addClass('all-depts-holder-hide');
		setTimeout(function() {
		$('.all-depts-holder').removeClass('all-depts-animation-reverse');
		$(".all-depts-dropdown").addClass('all-depts-active');
		}, 100);
		setTimeout(function() {
		$("#search-field").focus();
		}, 200);
	  });
	  
	$('.all-depts-close').click(function (e) { 
			$('.all-depts-dropdown').removeClass('all-depts-active');
			setTimeout(function() {
			$(".top-blur-overlay").removeClass("top-blur-overlay-active");
			$('.all-depts-holder').removeClass('all-depts-animation-reverse');
			$(".nav-cart").removeClass('nav-cart-hidden');
			$('#top-nav, #logo, .checkout').removeClass('all-depts-holder-hide');
			$('.all-depts-holder-list-mobile').removeClass('all-depts-holder-list-mobile-hide');
			}, 100);
			setTimeout(function() {
			$('.all-depts-holder').removeClass('all-depts-animation-reverse');
			}, 300);
			e.stopPropagation();
	});
	
	$(document).keyup(function(e) {
		 if (e.key === "Escape" || e.which == 27) { 
		$('.all-depts-dropdown').removeClass('all-depts-active');
		$('.grid-filter-holder').removeClass('filter-active');
		$(".nav-cart").removeClass('nav-cart-hidden');
		$('#top-nav, #logo, .checkout').removeClass('all-depts-holder-hide');
		setTimeout(function() {
		$(".top-blur-overlay").removeClass("top-blur-overlay-active");
		$('.all-depts-holder').removeClass('all-depts-animation-reverse');
		$('.all-depts-holder-list-mobile').removeClass('all-depts-holder-list-mobile-hide');
		}, 100);
		setTimeout(function() {
		$('.all-depts-holder').removeClass('all-depts-animation-reverse');
		}, 300);
		}
	});

$(document).ready(function(){
	var ctrlPressed = false; //Variable to check if the the first button is pressed at this exact moment
	$(document).keydown(function(e) {
	  if (e.ctrlKey || e.which == 91 || e.which == 93 || e.which == 224) { //If it's control key
		ctrlPressed = true; //Set variable to true
	  }
	}).keyup(function(e) { //If user releases ctrl button
	  if (e.ctrlKey || e.which == 91 || e.which == 93 || e.which == 224) {
		ctrlPressed = false; //Set it to false
	  }
	}); //This way you know if ctrl key is pressed. You can change e.ctrlKey to any other key code you want
	
	$(document).keydown(function(e) { //For any other keypress event
	  if (e.which == 75) { //Checking if it's space button
		if(ctrlPressed == true){ //If it's space, check if ctrl key is also pressed
		 $(".top-blur-overlay").addClass("top-blur-overlay-active");
		 $('.all-depts-holder-list-mobile').addClass('all-depts-holder-list-mobile-hide');
		 $(".nav-cart").addClass('nav-cart-hidden');
		 $('#top-nav, #logo, .checkout').addClass('all-depts-holder-hide');
		 setTimeout(function() {
		 $('.all-depts-holder').removeClass('all-depts-animation-reverse');
		 $(".all-depts-dropdown").addClass('all-depts-active');
		 }, 100);
		 setTimeout(function() {
		 $("#search-field").focus();
		 }, 200);
		  ctrlPressed = false; //Important! Set ctrlPressed variable to false. Otherwise the code will work everytime you press the space button again
		}
	  }
	})
	
	});
	
	// ADJUST MOBILE RIGHT SEARCH BASED ON CART WIDTH
	$(document).ready(function(){
		setTimeout(function() {
		var cartWidth = $('.nav-cart-mobile').outerWidth();
		var cartPadding = parseInt($('.nav-cart-mobile').css('margin-right'));
		var totalcartPadding = cartPadding * 2+ cartWidth;
		console.log ('Cart width: '+ cartWidth +' Cart Padding: '+ cartPadding +' Total Cart: '+ totalcartPadding);
		$('.all-depts-holder-list-mobile').css({ right: totalcartPadding });
		}, 200);
	});
	
	$(".wk-button").click(function(){
		if (GlobalLang == "FR") {
			var addMessage = "AJOUTER À VOS FAVORIS";
			var removeMessage = "RETIRÉ DE VOS FAVORIS";
		}
			else {
			var addMessage = "ADDED TO FAVOURITES";
			var removeMessage = "REMOVED FROM FAVOURITES";
			};
		var itemID = $(this).closest(".item").find("#add-to-cart-animation-wrapper").attr("data-product-id");
		if ($(this).closest(".item").find(".wk-selected")[0]){
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').html(removeMessage);
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').addClass('message-red');
			$(".item-" + itemID).find('.notifier-favourite .favourite-heart').addClass('checkmark-remove');
		} else {
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').html(addMessage);
			$(".item-" + itemID).find('.notifier-favourite .notifier-message').removeClass('message-red');
			$(".item-" + itemID).find('.notifier-favourite .favourite-heart').addClass('checkmark-show');
			$(".item-" + itemID).find('.notifier-favourite .favourite-heart').removeClass('checkmark-remove');
		}
		$(".item-" + itemID).find('.notifier-favourite').addClass('notifier-show');
		
		setTimeout(function() {$(".item-" + itemID).find('.notifier-favourite').removeClass('notifier-show');}, 1600);
		setTimeout(function() {$(".item-" + itemID).find('.notifier-favourite .favourite-heart').removeClass('checkmark-show');}, 1800);
	});
	